import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { FilingConductorSyncStatusResponse } from './types';

export interface UseFilingConductorSyncStatusParams {
  corporationId: number | null;
  rootFiCompanyId: number;
  syncFromDate?: string | null;
  refreshInterval?: number;
}

export function useFilingConductorSyncStatus({
  corporationId,
  rootFiCompanyId,
  syncFromDate,
  refreshInterval,
}: UseFilingConductorSyncStatusParams) {
  const path = corporationId
    ? `filing-conductor/corporations/${corporationId}/integrations/${rootFiCompanyId}/sync-status`
    : null;
  const key =
    path && syncFromDate ? `${path}?syncFromDate=${syncFromDate}` : path;

  const { data, error, isLoading, mutate } =
    useSWR<FilingConductorSyncStatusResponse>(
      key,
      SWRFetcher({ method: 'GET' }),
      { refreshInterval }
    );

  return {
    status: data?.status ?? null,
    syncId: data?.syncId ?? null,
    syncFromDate: data?.syncFromDate ?? null,
    isLoading,
    error,
    mutate,
  };
}
